export const messagesStatuses = {
  sent: "violet",
  delivered: "cyan",
  read: "lime",
  failed: "rose",
  null: "rose",
};
